import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ownerApi, type CreateOwnerManualPayload, type CreateOwnerManualResponse } from 'services/ownerApi'
import { ownerQueryKeys } from './ownerQueryKeys'

export interface UseOwnerCreateManualMutationOptions {
  onSuccess?: (data: CreateOwnerManualResponse) => void
  onError?: (error: any) => void
}

export const useOwnerCreateManualMutation = (options?: UseOwnerCreateManualMutationOptions) => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (payload: CreateOwnerManualPayload) => ownerApi.createManualOwner(payload),
    onSuccess: (data) => {
      // Invalidate owners list to refetch with new owner
      queryClient.invalidateQueries({ queryKey: ownerQueryKeys.lists() })
      options?.onSuccess?.(data)
    },
    onError: (error) => {
      options?.onError?.(error)
    },
  })

  return {
    createOwner: mutation.mutate,
    createOwnerAsync: mutation.mutateAsync,
    data: mutation.data,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  }
}
